import getStore from "../store/store";

export default function getBackgroundColor(): string {
    return getStore().backgroundColor;
}
